/* eslint-disable @angular-eslint/component-selector */
import { Component, EventEmitter, Input, Output } from '@angular/core';
import {
	expActionButtons,
	TableActionButton
} from './definitions/kng-grid.interface';

@Component({
	selector: '[action-buttons]',
	templateUrl: './template/action-buttons.component.html'
})
export class ActionButtonsComponent 
{
  @Input() value: string | undefined;
  @Output() buttonAction: EventEmitter<TableActionButton> =
  	new EventEmitter<TableActionButton>();

  onEditClick() 
  {
  	this.buttonAction.emit({
  		name: expActionButtons.actionButton.move,
  		value: this.value
  	});
  }
  onDeleteClick() 
  {
  	this.buttonAction.emit({ name: expActionButtons.actionButton.remove });
  }
  onViewClick() 
  {
  	this.buttonAction.emit({ name: expActionButtons.actionButton.move });
  }
}
